// extracted by mini-css-extract-plugin
export default {"container":"iI-z","disabled":"jI-z","bgBlack":"kI-z","content":"lI-z","countdown":"mI-z","topCaption":"nI-z","topHeading":"oI-z","heading":"pI-z","copy":"qI-z"};